import { TextFormatEnum as r } from "../text-format-enum.mjs";
import o from "../../../icons/bold-icon.mjs";
import c from "../../../icons/italic-icon.mjs";
import n from "../../../icons/strikethrough-icon.mjs";
import a from "../../../icons/underline-icon.mjs";
const f = ({
  formatType: t,
  editor: e
}) => {
  if (e)
    switch (t) {
      case r.Bold:
        e.chain().focus().toggleBold().run();
        break;
      case r.Italic:
        e.chain().focus().toggleItalic().run();
        break;
      case r.Underline:
        e.chain().focus().toggleUnderline().run();
        break;
      case r.Strike:
        e.chain().focus().toggleStrike().run();
        break;
    }
}, g = ({ formatType: t }) => {
  switch (t) {
    case r.Bold:
      return o;
    case r.Italic:
      return c;
    case r.Underline:
      return a;
    case r.Strike:
      return n;
  }
};
export {
  g as getTextFormatIcon,
  f as setTextFormat
};
